<template>
  <button
    class="btn"
    @click="$emit('click')"
    :type="type"
    :class="[...extraClass, { [preset]: !!preset, iconAtEnd, center }]"
    :style="{
      borderRadius: borderRadius + 'px',
      backgroundColor: hovering ? hoverColor : color,
      color: textColor,
      height: height ? height + 'px' : 'auto',
      width: width ? width : 'auto',
      minWidth: minWidth ? minWidth : 'auto',
      fontSize: fontSize
    }"
    @mouseover="mouseOver"
    @mouseout="mouseOut"
  >
    <i :class="icon" v-if="!preset"></i>
    <i class="fab fa-facebook-f" v-if="preset == 'facebook'"></i>
    <i class="fab fa-whatsapp" v-if="preset == 'whatsapp'"></i>
    <i class="fab fa-twitter" v-if="preset == 'twitter'"></i>
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "LogoHeader",
  data() {
    return {
      hovering: false
    };
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#fc0081"
    },
    hoverColor: {
      type: String,
      default: "#ff44a4"
    },
    textColor: {
      type: String,
      default: ""
    },
    fontSize: {
      type: String,
      default: "22px"
    },
    text: {
      type: String,
      default: ""
    },
    borderRadius: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0 // 0 = auto
    },
    type: {
      type: String
    },
    preset: {
      type: String,
      default: "" // facebook, whatsapp, twitter, text
    },
    iconAtEnd: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ""
    },
    minWidth: {
      type: String,
      default: ""
    },
    extraClass: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    mouseOver() {
      this.hovering = true;
    },
    mouseOut() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss">
.btn {
  border: 0;
  padding: 8px 20px;
  height: 45px;
  cursor: pointer;
  transition: 0.25s;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  // font-weight: bold;
  letter-spacing: 0.55px;
  min-height: 50px;

  font-family: "AmnestyTradeGothic";
  text-transform: uppercase;
  font-size: 22px;
  // font-weight: bold;
  letter-spacing: 0.55px;

  @media (max-width: 767px) {
    width: 100% !important;
    font-size: 22px !important;
    min-width: auto !important;

    &:last-of-type {
      margin-bottom: 0 !important;
    }
  }

  span {
    @media (max-width: 767px) {
      text-align: center;
      width: 100%;
    }
  }

  .fas,
  .fab {
    font-size: 20px;
    margin-right: 10px;
    font-weight: normal;
  }

  &.center {
    margin: 0 auto;
    display: block;
  }

  &.iconAtEnd {
    flex-direction: row-reverse;

    .fas,
    .fab {
      margin-left: 10px;
      margin-right: 0px;
    }
  }

  &.facebook {
    color: white;
    background-color: #3b5998 !important;
    &:hover {
      background-color: lighten(#3b5998, 10%) !important;
    }
  }

  &.whatsapp {
    color: white;
    background-color: #25d366 !important;
    @media only screen and (min-width: 767px) {
      display: none;
    }
    &:hover {
      background-color: lighten(#25d366, 10%) !important;
    }
  }

  &.twitter {
    color: white;
    background-color: #1da1f2 !important;
    &:hover {
      background-color: lighten(#1da1f2, 10%) !important;
    }
  }

  &.text {
    color: black;
    background: none !important;
    text-decoration: underline;
    padding: 4px 0;
    height: auto !important;
    min-height: auto !important;
    @media (max-width: 767px) {
      font-size: 18px !important;
      width: auto !important;
      margin: 0 auto !important;
      display: block;
    }
    &:hover {
      background: none !important;
      text-decoration: none;
    }
  }
}
</style>
